import React from "react";
import { Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, } from "@mui/material";

const ViewEditBilling = ({ lesson, onClose, selectedStudent, setSelectedStudent }) => {
  if (!lesson) {
    return (
      <Paper
        sx={{
          p: 2,
          border: "2px dashed #b0b0b0",
          borderRadius: 2,
          minHeight: "400px",
          width: "620px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "gray",
          bgcolor: "#fafafa",
        }}
      >
        <Typography variant="h6" color="text.secondary">
          Select Lesson
        </Typography>
      </Paper>
    );
  }

  const totalFee = lesson.fee * lesson.students.length;
  const totalPaid = lesson.students.reduce((sum, s) => sum + s.paid, 0);
  const totalDiscount = lesson.students.reduce((sum, s) => sum + s.discount, 0);
  const totalBalance = totalPaid + totalDiscount - totalFee;

  return (
    <Paper sx={{ p: 2, width: "588px", }}>
      <Typography variant="h6" gutterBottom>
        {lesson.name}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {new Date(lesson.startDttm).toLocaleString()} -{" "}
        {new Date(lesson.endDttm).toLocaleTimeString()}
      </Typography>

      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Student Name</TableCell>
            <TableCell align="right">Fee</TableCell>
            <TableCell align="right">Paid</TableCell>
            <TableCell align="right">Discount</TableCell>
            <TableCell align="right">Deposit</TableCell>
            <TableCell align="right">Lesson Balance</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lesson.students.map((s) => (
            <TableRow
              key={s.uid}
              onClick={() => {
                setSelectedStudent(s);
              }}
              sx={{
                cursor: "pointer",
                backgroundColor: selectedStudent?.uid === s.uid ? "#d0f0d0" : "white",
                "&:hover": {
                  backgroundColor: selectedStudent?.uid === s.uid ? "#d0f0d0" : "#e6f2ff",
                },
              }}
            >
              <TableCell>{s.name}</TableCell>
              <TableCell align="right">
                {s.fee} {lesson.ccy}
              </TableCell>
              <TableCell align="right">{s.paid}</TableCell>
              <TableCell align="right">{s.discount}</TableCell>
              <TableCell align="right">{s.deposit}</TableCell>
              <TableCell
                align="right"
                style={{
                  color: s.lessonBalance < 0 ? "red" : "green",
                }}
              >
                {s.lessonBalance}
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell>
              <strong>Total</strong>
            </TableCell>
            <TableCell align="right">{totalFee}</TableCell>
            <TableCell align="right">{totalPaid}</TableCell>
            <TableCell align="right">{totalDiscount}</TableCell>
            <TableCell />
            <TableCell
              align="right"
              style={{
                color: totalBalance < 0 ? "red" : "green",
              }}
            >
              {totalBalance}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default ViewEditBilling;
